import { createReducer } from "@reduxjs/toolkit";

const initialState = {
 loading : false ,
 Resources : null,
};

export const resourcesReducer = createReducer(initialState,{

    fetchResourcesRequest : (state) => {
        state.loading = true;
    },

    fetchResourcesSuccess : (state, action) => {
        state.loading = false;
        state.Resources = action.payload;
    },

    fetchResourcesFailure : (state,action) => {
        state.loading = false;
        state.error = action.payload;
    },
    
});